module.exports = __webpack_public_path__ + "static/media/logo-black.db507453.png";